<template>
    <v-row
        no-gutters
    >
        <v-col>
            <v-dialog
                v-if="editModal.open"
                v-model="editModal.open"
                :width="500">
                <AdminMemberDialog
                    :payload="editModal.payload"
                    @close="onCloseClick"
                >
                </AdminMemberDialog>
            </v-dialog>

            <v-row no-gutters>
                <v-col class="mb-2">
                    <ModernFilterBar
                        :filter-controller="filterController"
                    >
                    </ModernFilterBar>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-toolbar
                        flat
                        class="medium-toolbar"
                        color="transparent"
                    >
                        <v-toolbar-title class="font-weight-bold mb-3">
                            {{ richDataTableController.getTotalRows() }}
                            {{ "leads" }}
                        </v-toolbar-title>
                    </v-toolbar>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <RichDataTable
                        :rich-data-table-controller="richDataTableController"
                    >
                        <template v-slot:item.intercom_url="{ item }">
                            <div class="text-right">
                                <v-btn icon text color="n3" class="mr-2"
                                       :hidden="!item.intercom_url"
                                       @click="onUrlClick(item.intercom_url)">
                                    <v-icon>web</v-icon>
                                </v-btn>
                            </div>
                        </template>

                        <template v-slot:item.mailchimp_url="{ item }">
                            <div class="text-right">
                                <v-btn icon text color="n3" class="mr-2"
                                       :hidden="!item.mailchimp_url"
                                       @click="onUrlClick(item.mailchimp_url)">
                                    <v-icon>web</v-icon>
                                </v-btn>
                            </div>
                        </template>

                        <template v-slot:item.edit="{ item }">
                            <div class="text-right">
                                <v-btn
                                    icon
                                    text
                                    color="n3"
                                    class="mr-2"
                                    @click="onEditClick(item)"
                                >
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </div>
                        </template>
                    </RichDataTable>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import {onMounted, reactive} from "@vue/composition-api"
import AccountModule from "../../store/modules/account"
import AdminMemberDialog from "./AdminMemberDialog.vue"
import ModernFilterBar from "@/components/ModernFilterBar/index.vue";
import RichDataTable from "@/components/RichDataTable/RichDataTable.vue";
import UrlAdapter from "@/urlAdapter/urlAdapter";
import FilterBarController from "@/components/ModernFilterBar/FilterBarController";
import RichDataTableController from "@/components/RichDataTable/RichDataTableController";

export default {
    name: "AdminLead",
    components: {RichDataTable, ModernFilterBar, AdminMemberDialog},
    setup() {
        const urlAdapter = new UrlAdapter()

        const accountModule = AccountModule()

        const filters = [
            {key: "user_search", default_value: [''], default: true},
        ]

        /** @type {FilterBarController} */
        const filterController = reactive(FilterBarController.init(urlAdapter))

        /** @type {RichDataTableController} */
        const richDataTableController = reactive(RichDataTableController.initAsync(urlAdapter))
        const options = [
            {key: "sortBy", default_value: "lead_at"},
            {key: "sortDesc", default_value: true},
            {key: "itemsPerPage", default_value: 50},
            {key: "page", default_value: 1}
        ]
        richDataTableController.setDefaultOptions(options)

        const headers = [
            {text: "", value: "edit", sortable: false},
            {text: ("Id"), value: "row_id"},
            {text: ("Lead at"), value: "lead_at", width: "120"},
            {text: ("Status"), value: "status"},
            {text: ("Email"), value: "email"},
            {text: ("Name"), value: "name"},
            {text: ("Demo at"), value: "demo_at", width: "120"},
            {text: ("Demo count"), value: "demo_count"},
            {text: ("Mailchimp"), value: "mailchimp_url"},
        ]

        const backendQuery = async () => {
            let params = {...filterController.getCurrentFilterValues(), ...richDataTableController.getOptions()}

            const resp = await accountModule.fetchAdminData('lead', params)
            richDataTableController.setRows(resp.items, resp.leads_count)
        }

        const onUrlClick = function (url) {
            window.open(url, '_blank')
        }

        const editModal = reactive({open: false, payload: {}})
        const onEditClick = function (payload) {
            editModal.payload = payload
            editModal.open = true
        }
        const onCloseClick = function (payload) {
            editModal.payload = null
            editModal.open = false
            backendQuery()
        }

        onMounted(async () => {
            filterController.initFilters(filters)

            filterController.startUrlWatcher()

            richDataTableController.setAllHeaders(headers)
            richDataTableController.setVisibleHeaders(headers.map(x => x.value))

            await filterController.persistCurrentFilterStateToUrl()
            richDataTableController.setLoadDataFunc(backendQuery)
            await richDataTableController.loadDataFunc()
        })

        return {
            editModal,
            onEditClick,
            onCloseClick,
            onUrlClick,
            richDataTableController,
            filterController
        }
    }
}
</script>
